<template>
    <div style="margin: 0 0 0 0;">
        <el-card class="zgxq">
            <el-row>

                <el-col :span="24">
                    <span style="line-height: 2rem; font-size: 1.5rem; text-align: center">岗点列表</span>
                </el-col>

            </el-row>

            <el-row style="margin-top:20px;margin-bottom: 20px;text-align: left" >
                <el-col :span="3">
                    <el-input  @change="changeIndex"
                               placeholder="请输入职员代码"
                               v-model="searchForm.username"
                               clearable>
                    </el-input>
                </el-col>
                <el-col :span="3">
                    <el-input  @change="changeIndex"
                               placeholder="请输入职员姓名"
                               v-model="searchForm.xm"
                               clearable>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input  @change="changeIndex"
                               placeholder="请输入岗点名称"
                               v-model="searchForm.gdmc"
                               clearable>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-select @change="changeIndex" clearable :disabled="deptdisable"   filterable    v-model="searchForm.bmid" placeholder="请选择大队">
                        <el-option
                                v-for="item in depts"
                                :key="item.bmid"
                                :label="item.bmmc"
                                :value="item.bmid"
                                :disabled="deptdisable">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-button type="primary" @click="loadData()">查询</el-button>
                    <el-button type="primary" v-if="isAuth('gdxx:setHsj')" @click="setHoliday()">设置寒暑假</el-button>

                    <el-button type="primary" @click="goMap()">地图模式</el-button>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-table id="map_table"  v-loading="loading" :data="tableData" border  style="width: 100%">
                        <el-table-column label="名称" prop="gdmc">
                        </el-table-column>
                        <el-table-column prop="zbjd" label="经度" width="120">
                        </el-table-column>
                        <el-table-column  prop="zbwd" label="纬度" width="120">
                        </el-table-column>
                        <el-table-column  prop="dkjl" label="打卡距离" width="90">
                        </el-table-column>
<!--                        <el-table-column  prop="dkrs" label="人数">-->
<!--                        </el-table-column>-->
                        <el-table-column  prop="morrs" label="早班人数" width="90">
                        </el-table-column>
                        <el-table-column  prop="aftrs" label="中班人数" width="90">
                        </el-table-column>
                        <el-table-column  prop="evers" label="夜班人数" width="90">
                        </el-table-column>

                        <el-table-column label="操作" :render-header="renderHeader" >
                            <template slot-scope="scope">
                                <el-button v-if="isAuth('gangdian:setuser') && (scope.row.hxgd !== 1)" @click="setUser(scope.row)" type="text" size="mini">设置人员</el-button>
                                <el-button v-if="isAuth('gangdian:settempuser') && (scope.row.hxgd !== 1)" @click="setTempUser(scope.row)" type="text" size="mini">设置临时人员</el-button>
                                <el-button v-if="isAuth('gdxx:setHsj')&&(scope.row.hxgd?scope.row.hxgd === 1:false)" @click="setSchoolHoliday(scope.row)" type="text" size="mini">寒暑假</el-button>
                                <el-button v-if="(scope.row.hxgd !== 1)" @click="showUser(scope.row)" type="text" size="mini">查看人员</el-button>
                                <el-button @click="dwClick(scope.row)" type="text" size="mini">定位</el-button>
                                <el-button v-if="isAuth('gangdian:setSchoolBbxx')" @click="setSchoolBbxx(scope.row)" type="text" size="mini">设置校园班别打卡人数</el-button>
                                <el-button v-if="isAuth('gangdian:update')" @click="updateClick(scope.row)" type="text" size="mini">修改</el-button>
                                <el-button v-if="isAuth('gangdian:delete')" @click="deClick(scope.$index,scope.row)" type="text" size="mini">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-dialog
                    style="text-align: left"
                    title="导出"
                    :visible.sync="exportVisible"
            >
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
                    <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
                </el-checkbox-group>
                <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/map/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
                    <input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
                    <input type="hidden" name="fileds" value="" ref="fileds"/>
                </form>
                <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
            </el-dialog>
            <gangdian-user  v-if="userVisible" ref="user"></gangdian-user>
            <add-or-update v-if="updateVisible" ref="update" @refreshDataList="loadData"></add-or-update>
            <set-user v-if="setUsetVisible" ref="setuser" @refreshDataList="loadData"></set-user>
            <set-temp-user v-if="setUsetTempVisible" ref="setusertemp" @refreshDataList="loadData"></set-temp-user>
            <el-pagination background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
            <school-holidays v-if="schoolHolidayVisible" ref="schoolHoliday"></school-holidays>
            <batch-set-holiday v-if="batchHolidayVisible" ref="batchHoliday"></batch-set-holiday>
        </el-card>
        <gdxx-school-bbxx v-if="schoolBbxxVisible" ref="schoolBbxx" @refreshDataList="loadData"></gdxx-school-bbxx>
    </div>
</template>

<script >
    import store from '../../../store'
    import {
        Vue,
        Component
    } from 'vue-property-decorator'
    import GangdianUser from './gangdian-user'
    import AddOrUpdate from  './gangdian-add-or-update'
    import SetUser from  './gangdian-setuser'
    import SetTempUser from './gangdian-settempuser'
    import SchoolHolidays from './school-holidays'
    import BatchSetHoliday from './batch-set-holiday'
    import GdxxSchoolBbxx from './gdxx-school-bbxx'
    const exportFields=[
        {value:"gdmc",name:"岗点名称"},
        {value:"dkjl",name:"打卡距离"},
        {value:"bz",name:"备注"},
        {value:"morrs",name:"早班人数"},
        {value:"aftrs",name:"午班人数"},
        {value:"evers",name:"晚班人数"},
        {value:"zbsbsj",name:"早班上班时间"},
        {value:"zbxbsj",name:"早班下班时间"},
        {value:"wbsbsj",name:"中班上班时间"},
        {value:"wbxbsj",name:"中班下班时间"},
        {value:"ybsbsj",name:"夜班上班时间"},
        {value:"ybxbsj",name:"夜班下班时间"},
        {value:"bmmc",name:"部门名称"},
        {value:"zbjd",name:"经度"},
        {value:"zbwd",name:"纬度"}
    ]
    @Component({
        name: 'gwlb',
        components:{
            GangdianUser:GangdianUser,
            AddOrUpdate: AddOrUpdate,
            SetUser:SetUser,
            SetTempUser:SetTempUser,
            SchoolHolidays,
            BatchSetHoliday,
            GdxxSchoolBbxx
        }
    })

    export default class zgxq extends Vue {

        username=store.getters.user.username
        deptdisable=false
        depts=[]
        currentPage=1
        pagesize=10
        total=0
        loading=true
        tableData=[]
        userVisible=false
        updateVisible=false
        setUsetVisible=false
        setUsetTempVisible=false
        schoolHolidayVisible=false
        batchHolidayVisible=false
        schoolBbxxVisible=false
        isIndeterminate=false
        exportVisible=false
        checkAll=false
        fields=exportFields
        searchForm = {
            username:'',
            xm:'',
            gdmc:'',
            bmid:'',
            page:'',
            pagesize:''
    }
        filedValues=exportFields.map(item => item.value)
        fieldList=[]
        mounted() {
            let that = this;
            this.getDepts()


        }
        goMap() {
            this.$router.push({path:'/bjba/map'});
        }
        getParams() {
                this.searchForm.page=this.currentPage
                this.searchForm.pagesize=this.pagesize
        }
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        }
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        }

        showExportDialog() {
            this.exportVisible = true
        }
        renderHeader (h) {
            return (
                <div class="clearfix">
                    <span>操作</span>
                    <el-button style="padding:5px;float:right" size="mini"
            onClick={()=>this.showExportDialog()}>导出</el-button></div>
        )
        }
        exportExcel() {
            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.getParams();
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        }
        loadData() {
            this.getParams();
            this.$request({
                method: 'get',
                url: '/bjba/map/getGdPage',
                params:this.searchForm
            }).then((response) => {
                this.loading=false
                this.tableData = response.data.content
                this.total = response.data.totalElements
            })
        }
        deClick(index, row) {
            let that=this;
            that.$confirm('是否确定删除此岗点信息', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$request({
                    method: 'get',
                    url: '/bjba/map/deleteGdxx',
                    params: {
                        id: row.gdid
                    }
                }).then((response) => {
                    this.$message.success("删除成功！");
                    this.loadData();
                }).catch(err => {
                    console.log(err)
                    alert("删除失败！")
                })
            }).catch(() => {});
        }
        updateClick(row) {
            this.updateVisible = true
            this.$nextTick(() => {
                this.$refs.update.init(row.gdid)
            })
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc){
                        if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.searchForm.bmid = that.depts[0].bmid
                                    this.deptdisable = true

                                }

                            }
                        }

                    }

                }
                this.loadData();
            })
        }
        pageUser(page) {
            this.currentPage = page
            this.loadData()
        }
        changeIndex() {
            this.currentPage = 1
        }
        dwClick(row) {
            let x = row.zbjd;
            let y = row.zbwd;
            this.$router.push({path:'/bjba/map',
                query:{x:x,y:y}});
        }
        showUser(row) {
            this.userVisible = true
            this.$nextTick(() => {
                this.$refs.user.init(row.gdid)
            })
        }
        setUser(row) {
            this.setUsetVisible = true
            this.$nextTick(() => {
                this.$refs.setuser.init(row.gdid)
            })
        }
        setTempUser(row) {
            this.setUsetTempVisible = true
            this.$nextTick(() => {
                this.$refs.setusertemp.init(row.gdid)
            })
        }
        setSchoolHoliday(row) {
            this.schoolHolidayVisible = true
            this.$nextTick(() => {
                this.$refs.schoolHoliday.init(row.gdid)
            })
        }
        setHoliday() {
            this.batchHolidayVisible = true
            this.$nextTick(() => {
                this.$refs.batchHoliday.init()
            })
        }
        setSchoolBbxx(row) {
            this.schoolBbxxVisible = true
            this.$nextTick(() => {
                this.$refs.schoolBbxx.init(row.gdid)
            })
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .zgxq {
        height: 100%;
        width: 100%;
    }
    .zgxq-card {
        height: 100%;
        width: 100%;
    }
</style>
